
import Vue from "vue";

export default Vue.extend({
  computed: {
    transactionId(): string {
      return this.$route.params && this.$route.params.id;
    },
  },
});
